/**
 * Symbol key that carries API call info interpreted by this Redux middleware.
 *
 * @constant {symbol}
 * @access public
 * @default
 */
'use strict';

var _Symbol = require('babel-runtime/core-js/symbol')['default'];

exports.__esModule = true;
var CALL_API = _Symbol('Call API');

exports['default'] = CALL_API;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/redux-api-middleware/lib/CALL_API.js
// module id = 230
// module chunks = 0